export default "__VITE_ASSET__Rscg$2_z__"